export enum ItemsActionTypes {
  ADD_COMMENT_SUCCESS = 'ADD_COMMENT_SUCCESS',
  ADD_COMMENT_FAIL = 'ADD_COMMENT_FAIL',
  ADD_COMMENT_LOADING = 'ADD_COMMENT_LOADING',
  CLEAR_MAP_ITEM_ERROR = 'CLEAR_MAP_ITEM_ERROR',
  CLEAR_MAP_ITEM_DETAILS = 'CLEAR_MAP_ITEM_DETAILS',
  DELETE_IMAGE_SUCCESS = 'DELETE_IMAGE_SUCCESS',
  DELETE_MAP_ITEM_SUCCESS = 'DELETE_MAP_ITEM_SUCCESS',
  EDIT_MAP_ITEM_SUCCESS = 'EDIT_MAP_ITEM_SUCCESS',
  GET_COMMENTS_SUCCESS = 'GET_COMMENTS_SUCCESS',
  GET_IMAGE_LOCATION_SUCCESS = 'GET_IMAGE_LOCATION_SUCCESS',
  GET_LIKES_SUCCESS = 'GET_LIKES_SUCCESS',
  GET_MAP_ITEM_SUCCESS = 'GET_MAP_ITEM_SUCCESS',
  GET_MAP_ITEM_DETAILS_SUCCESS = 'GET_MAP_ITEM_DETAILS_SUCCESS',
  GET_MAP_ITEMS_SUCCESS = 'GET_MAP_ITEMS_SUCCESS',
  TOGGLE_LIKE_SUCCESS = 'TOGGLE_LIKE_SUCCESS'
}

export interface GetMapItemsSuccessAction {
  type: ItemsActionTypes.GET_MAP_ITEMS_SUCCESS;
  payload: any;
}

export interface GetMapItemSuccessAction {
  type: ItemsActionTypes.GET_MAP_ITEM_SUCCESS;
  payload: any;
}

export interface GetMapItemDetailsSuccessAction {
  type: ItemsActionTypes.GET_MAP_ITEM_DETAILS_SUCCESS;
  payload: any;
}

export interface getImageLocationSuccess {
  type: ItemsActionTypes.GET_IMAGE_LOCATION_SUCCESS;
  payload: {
    uploaded: boolean;
    preImageGeoData?: {
      latitude: Number[];
      longitude: Number[];
    };
  };
}

export interface DeleteImageSuccess {
  type: ItemsActionTypes.DELETE_IMAGE_SUCCESS;
  payload: {
    uploaded: boolean;
  };
}

export interface DeleteMapItemSuccessAction {
  type: ItemsActionTypes.DELETE_MAP_ITEM_SUCCESS;
  payload: any;
}

export interface EditMapItemSuccessAction {
  type: ItemsActionTypes.EDIT_MAP_ITEM_SUCCESS;
  payload: any;
}

export interface ClearMapItemErrorAction {
  type: ItemsActionTypes.CLEAR_MAP_ITEM_ERROR;
  payload: {
    id: number;
  };
}

export interface ClearMapItemDetailsAction {
  type: ItemsActionTypes.CLEAR_MAP_ITEM_DETAILS;
}

export interface Comment {
  id: string;
  _id: string;
  text: string;
  username: string;
  avatarUrl?: string;
  createdAt: string;
}

export interface GetCommentsSuccessAction {
  type: ItemsActionTypes.GET_COMMENTS_SUCCESS;
  payload: {
    comments: Comment[];
  };
}

export interface AddCommentSuccessAction {
  type: ItemsActionTypes.ADD_COMMENT_SUCCESS;
  payload: {
    comment: Comment;
  };
}

export interface AddCommentFailAction {
  type: ItemsActionTypes.ADD_COMMENT_FAIL;
}

export interface AddCommentLoadingAction {
  type: ItemsActionTypes.ADD_COMMENT_LOADING;
}

export interface GetLikesSuccessAction {
  type: ItemsActionTypes.GET_LIKES_SUCCESS;
  payload: {
    likesCount: number;
    userLiked: boolean;
    commentId: string;
  };
}

export interface ToggleLikeSuccessAction {
  type: ItemsActionTypes.TOGGLE_LIKE_SUCCESS;
  payload: {
    liked: boolean;
    likesCount: number;
    commentId: string;
  };
}


export type ItemsActions =
  | EditMapItemSuccessAction
  | DeleteMapItemSuccessAction
  | GetMapItemsSuccessAction
  | getImageLocationSuccess
  | GetMapItemSuccessAction
  | GetMapItemDetailsSuccessAction
  | DeleteImageSuccess
  | GetCommentsSuccessAction
  | AddCommentLoadingAction
  | AddCommentFailAction
  | AddCommentSuccessAction
  | GetLikesSuccessAction
  | ToggleLikeSuccessAction
  | ClearMapItemErrorAction
  | ClearMapItemDetailsAction;
